import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { Space } from 'antd';
import useForm from '../../../hooks/useForm';

import PageTitle from '../../PageTitle';
import FormWrapper from '../../FormWrapper';
import SaveButton from '../../buttons/SaveButton';
import CancelButton from '../../buttons/CancelButton';
import usePermissions from '../../../hooks/usePermission';

const permissionsMap = {
  canEdit: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
};

const EditEquipmentBrandForm = ({ brand, onSubmit, onCancel }) => {
  const { t } = useTranslation();
  const { canEdit } = usePermissions(permissionsMap);
  const validationSchema = useMemo(
    () =>
      yup.object().shape({
        name: yup.string().trim().required(t('errors.notEmpty')),
      }),
    [t],
  );

  const { handleSubmit, value, input } = useForm({
    initialValue: brand,
    schema: validationSchema,
    onSubmit,
    onCancel,
  });

  const { deleted } = value;

  return (
    <>
      <form onSubmit={handleSubmit}>
        <PageTitle
          title={brand.name || t('entity.taxonomy.equipmentBrand._singular')}
        />
        <FormWrapper>
          <FormWrapper.Single>
            <FormWrapper.Input
              label={t('entity.taxonomy.equipmentBrand.name')}
              props={{
                ...input('name'),
                disabled: deleted || !canEdit,
              }}
            />
          </FormWrapper.Single>
        </FormWrapper>
        <Space>
          {canEdit && <SaveButton disabled={deleted} />}
          <CancelButton onCancel={onCancel} />
        </Space>
      </form>
    </>
  );
};
export default EditEquipmentBrandForm;
